import { subscriptionTypes } from '@constants/index';

const LiteType = [subscriptionTypes.LITE];

const isNotLiteTypeSubscription = (subscription) =>
  !LiteType.includes(subscription.subscription.type);

export default isNotLiteTypeSubscription;
